import { type TFunction } from 'react-i18next';
import { type RouterSpecsFragment } from '../../../../api/fragments/RouterSpecs';
import * as implementations from './implementations';
import { type EndpointImplementation } from './implementations/types';

type EndpointSpecs = RouterSpecsFragment['endpoints'][number];

export const renderViewPanel = (endpoint: EndpointSpecs, router: RouterSpecsFragment) => {
    const { ViewPanelComponent } = implementations[endpoint.__typename] as EndpointImplementation<EndpointSpecs, any>;

    if (!ViewPanelComponent) {
        return null;
    }

    return <ViewPanelComponent endpoint={endpoint} router={router} />;
};

export const hasViewPanel = (endpoint: EndpointSpecs) => !!implementations[endpoint.__typename].ViewPanelComponent;

export const getIsPrivate = (endpoint: EndpointSpecs) =>
    implementations[endpoint.__typename].getIsPrivate(endpoint as any);

export const renderFormForEndpointType = (endpoint: EndpointSpecs, router: RouterSpecsFragment) => {
    const { FormComponent } = implementations[endpoint.__typename];

    return <FormComponent endpoint={endpoint} router={router} />;
};

export const getFormInitialValues = (endpoint: EndpointSpecs) =>
    implementations[endpoint.__typename].getFormInitialValues(endpoint as any);

export const getTitle = (endpoint: EndpointSpecs, t: TFunction) => implementations[endpoint.__typename].getTitle(t);

export { implementations };
